import React from 'react';
import Helmet from 'react-helmet';
import { useIntl } from 'react-intl';
import { App } from '@gin-betting/core';
import { OrderedSet } from 'immutable';

import { EventInfo, Loader, NoResults } from 'components';
import globalMessages from 'messages';
import matchList from 'modules/match-list';
import { getProductName } from 'utils';
import useFeaturedTournamentPage from './useFeaturedTournamentPage';

import './featuredTournamentPage.scss';

const {
    components: { UpcomingMatchList },
} = matchList;

const FeaturedTournamentPage: React.FC = () => {
    const { formatMessage } = useIntl();

    const {
        config,
        isMedium,
        isSmall,
        fetchStatus,
        matchesIds,
        readyIndicator,
        isLoadingConfig,
    } = useFeaturedTournamentPage();

    const isShowContent =
        ![App.FetchStatus.INITIAL, App.FetchStatus.LOADING].includes(
            fetchStatus
        ) && !isLoadingConfig;
    const isEmpty =
        matchesIds.length === 0 && fetchStatus === App.FetchStatus.LOADED;

    const Content = config ? (
        <React.Fragment>
            <EventInfo
                hasBackButton={true}
                slug={config.slug}
                name={config.title}
                logo={config.image}
                description={!isMedium ? config.description : undefined}
            />

            {isEmpty ? (
                <NoResults type={App.PageType.LIST} />
            ) : (
                <UpcomingMatchList
                    isMedium={isMedium}
                    isSmall={isSmall}
                    matchIds={OrderedSet(matchesIds)}
                />
            )}
        </React.Fragment>
    ) : (
        <NoResults type={App.PageType.INNER} />
    );

    return (
        <div styleName="container">
            <Helmet
                title={formatMessage(globalMessages.tournamentTitle, {
                    tournamentName: config?.title,
                    productName: getProductName(),
                })}
                onChangeClientState={newState => {
                    if (newState.title) {
                        readyIndicator.setReady('hasTitle');
                    }
                }}
            />

            <div styleName="loader-block">
                <Loader initialProgressValue={0} fetchStatus={fetchStatus} />
            </div>

            {isShowContent && Content}
        </div>
    );
};

export default React.memo(FeaturedTournamentPage);
